import { UsersRound, ShieldCheck, Sparkles, Star } from "lucide-react";

const PROPS = [
  {
    Icon: UsersRound,
    title: "Professionel service",
    text: "Vi leverer erfarent, imødekommende og service-orienteret personale til enhver begivenhed.",
  },
  {
    Icon: ShieldCheck,
    title: "Fleksibel løsning",
    text: "Uanset om det er en intim middag eller en stor event, tilpasser vi os jeres behov.",
  },
  {
    Icon: Sparkles,
    title: "Kvalificeret team",
    text: "Vores personale er oplært, pålideligt og klar til at skabe den bedste oplevelse.",
  },
  {
    Icon: Star,
    title: "Din succes, vores prioritet",
    text: "Vi går ikke på kompromis med kvaliteten – jeres tilfredshed er altid vores mål.",
  },
];

export const ValueProps = () => {
  return (
    <section className="py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="rounded-2xl border border-[color:var(--rs-border)] bg-[color:var(--rs-panel)] px-6 py-14 lg:px-12">
          <div className="text-center">
            <h2 className="font-heading text-3xl tracking-tight text-[color:var(--rs-text)] lg:text-4xl">
              Personale til fest &amp; event
            </h2>
            <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[color:var(--rs-gold)]">
              Tjenere · Bartendere · Eventpersonale · Opvaskere · Overtjenere/afviklere
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {PROPS.map((p) => (
              <div key={p.title} className="flex flex-col items-start">
                <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-[color:var(--rs-gold)]/50 text-[color:var(--rs-gold)]">
                  <p.Icon size={22} />
                </span>
                <h3 className="text-sm font-semibold uppercase tracking-widest text-[color:var(--rs-gold)]">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--rs-muted)]">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
